import {React}  from "react";
import {useForm,FormProvider,useFormContext }  from "react-hook-form";
import { Button,Card,Form,Container,Row, Col, } from "react-bootstrap";
import { cargosSistema } from "data/obtenerUsuariosSistema";
import { useUsuarioSistema } from '../hooks/useUsuarioSistema';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';

function CrearUsuarioSistema (Usuario){
  const methods = useForm()
  const { usuarioSistema,setUsuarioSistema,createUsuarioSistema,respuestaServicio } = useUsuarioSistema();
  let labelNombres="";
  const handleChange = event => {
    let valor=event.target.value;
    if(event.target.className=='form-check-input'){
      valor=event.target.checked;
    }
    
    setUsuarioSistema({ ...usuarioSistema, [event.target.name]: valor });
  };

  const onSubmit=methods.handleSubmit(data=>{
    //console.log("submit");
    createUsuarioSistema(usuarioSistema);
  });
 
  return (
    <>
      <Container fluid>
        <FormProvider {...methods}>
          <Form 
          onSubmit={e=>e.preventDefault()}
          noValidate
          className=""
          >
          <Row>
              <Col md="8">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">Agregar Usuario Sistema</Card.Title>
                  </Card.Header>
                  <Card.Body>
                    
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <label>Usuario</label>
                            <Form.Control
                              defaultValue={usuarioSistema?.Usuario}
                              disabled
                              placeholder=""
                              type="text">
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col  md="6">
                          <Form.Group>
                          <label>Nombres</label>
                          <Form.Control
                            defaultValue={usuarioSistema?.Nombres}
                            onChange={handleChange}
                                                    placeholder=""
                                                    type="text"
                                                    name="Nombres"
                                                    id="Nombres"
                                                    //required={true}
                                                   

                                                    
                                                    >
                          </Form.Control> 
                         
                            
                          </Form.Group>
                        </Col>
                      </Row>
                      
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <label>Apellido Primario</label>
                            <Form.Control
                              defaultValue={usuarioSistema?.ApellidoPrimario}
                              name="ApellidoPrimario"
                              onChange={handleChange}
                              type="text"
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="6">
                          <Form.Group>
                            <label>Apellido Secundario</label>
                            <Form.Control
                              defaultValue={usuarioSistema?.ApellidoSecundario}
                              name="ApellidoSecundario"
                              onChange={handleChange}
                              placeholder=""
                              type="text"
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <label>Nombre Social</label>
                            <Form.Control
                              //value={usuarioSistema.NombreSocial}
                              defaultValue={usuarioSistema?.NombreSocial}
                              placeholder=""
                              type="text"
                              name="NombreSocial"
                              onChange={handleChange}
                              
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="6">
                        <Form.Group>
                            <label>Correo</label>
                            <Form.Control
                              defaultValue={usuarioSistema?.Correo}
                              //value={usuarioSistema.Correo}
                              placeholder=""
                              type="text"
                              name="Correo"
                              onChange={handleChange}
                            ></Form.Control>
                          </Form.Group>
                          
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <label>Rut</label>
                            <Form.Control
                              defaultValue={usuarioSistema?.Rut}
                              //value={usuarioSistema.Rut}
                              placeholder="1-9"
                              type="text"
                              name="Rut"
                              onChange={handleChange}
                              
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="6">
                        <Form.Group>
                            <label>Genero</label>
                            <Form.Control as="select"
                            defaultValue={usuarioSistema?.Genero}
                            name="Genero"
                            onChange={handleChange}
                            //value={usuarioSistema?.Genero}
                            >
                              <option value="F">Femenino</option>
                              <option value="M">Masculino</option>
                              <option value="N">No indicar</option>
                              
                            </Form.Control>
                          </Form.Group>
                          
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <label>Teléfono</label>
                            <Form.Control
                              defaultValue={usuarioSistema?.Telefono}
                              //value={usuarioSistema.Telefono}
                              placeholder="+56959..."
                              type="text"
                              name="Telefono"
                              onChange={handleChange}
                              
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="6">
                        <Form.Group>
                            <label>Fecha de Nacimiento</label>
                            <Form.Control
                              
                              defaultValue={usuarioSistema?.FechaNacimiento}
                              //value={usuarioSistema.FechaNacimiento}
                              placeholder=""
                              type="date"
                              name="FechaNacimiento"
                              onChange={handleChange}
                              //onChange={(e) => setDate(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                          
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                        
                          <Form.Group>
                            <label>Cargo</label>
                            <label htmlFor="CargoId" className="font-semibold capitalize"></label>
                            <Form.Control 
                            as="select" 
                            name="CargoId" 
                            id="CargoId"
                            onChange={handleChange}
                            value={usuarioSistema?.CargoId}
                            >
                              <option value="6">Practicante</option>
                              <option value="5">Terapeuta Ocupacional</option>
                              <option value="4">Tallerista</option>
                              <option value="3">Psicóloga</option>
                              <option value="2">Coordinadora</option>
                              <option value="1">Administrativo</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="6">
                          
                          <Form.Group>
                            <label>Habilitado</label>
                            <label htmlFor="Habilitado" className="font-semibold capitalize"></label>
                            <Form.Check className="mb-1 pl-0">
                                <Form.Check.Label>
                                  <Form.Check.Input
                                    defaultChecked={usuarioSistema?.Habilitado}
                                    id="Habilitado"
                                    name="Habilitado"
                                    //checked={usuarioSistema?.Habilitado}
                                    type="checkbox"
                                    onChange={handleChange}
                                  ></Form.Check.Input>
                                  <span className="form-check-sign"></span>
                                </Form.Check.Label>
                              </Form.Check>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <MensajeAlerta mensajeTexto={respuestaServicio.mensajeTexto} estado={respuestaServicio.estado} />
                        </Col>
                      
                      </Row>
                      <Row style={{textAlign:'right'}} >
                      
                      <Col xs="5"></Col>
                      <Col xs="6" >
                                        
                      <Button
                        id="BtnCrearUsuarioSistema"
                        className="btn-fill btn-lg"
                        type="submit"
                        variant="info"
                        onClick={onSubmit}>
                        Guardar
                      </Button>

                      </Col>
                      </Row>
                      <div className="clearfix"></div>
                      <br></br><br></br>
                  </Card.Body>
                </Card>
              </Col>
          </Row>
          </Form>
      </FormProvider>
      </Container>
    </>
  );
  
}
export default CrearUsuarioSistema;


